import { Pagination } from "antd";
import styled from "styled-components";

export const Pager = styled(Pagination)`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
`;
